import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AuthService } from 'src/app/services/api/auth/auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CategoryService } from 'src/app/services/api/categories/category.service';
import { assetUrl } from 'src/app/globals/globals';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  assetUrl = assetUrl;

  public activeRoute = '';

  categories: any;
  menuMobileVisible: boolean = false;
  urlMktplace:string = `${environment.URL_MKTPLACE}`;

  currentUser: any;
  guestUser: boolean = true;
  userToken?: string | null;
  userBalance: number = 0;
  avatarUrl: any;

  isMobile: boolean = false;

  links = [
    { label: 'Home', url: '/'},
    { label: 'Programa Shell Box', url: '/programa' },
    { label: 'App Shell Box', url: '/app' },
    { label: 'Market Shell', url: '/marketshell.shell.com.ar/' },
    { label: 'Beneficios', url: '/beneficios-y-descuentos' }
  ];
  option = [
    { label: 'Mi perfil', url: '/perfil'},
    { label: 'Conversor de puntos', url: '/conversor' },
    { label: 'Mis puntos Shell Box', url: '/historial' },
    { label: 'Transferencia de puntos', url: '/transferencia-puntos' },
    { label: 'Historial de sorteos', url: '/historial-sorteos' },
  ];
  userInitials: string;

  constructor(private router: Router,
    public authService: AuthService,
    private categoryService: CategoryService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

    router.events.subscribe(val => {
      this.activeRoute = router.url.toString();
    });
  }

  ngOnInit(): any {
    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener('UserSessionRefreshed', (e: Event) => {
        this.handleUser();
      }, false);
    }
    this.handleUser();

    this.getCategories();

    if (isPlatformBrowser(this.platformId)) {
      const user = localStorage.getItem('user');
      let tthis = this;
        setInterval(function(){
          tthis.authService.IsSessionValid();
        }, 10000);
    }
  }

  isActive(url: string): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return window.location.pathname === url;
    }
    return false;
  }

  onRegistrarmeClick(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'click_Registrarme_NavBar_DL', 'boton': 'boton_Registrarme_NavBar' });    
      document.getElementsByClassName('modal-register')[0].classList.add('visible');
      document.getElementsByTagName('body')[0].classList.add('noScroll');
    }
  }

  showMenuMobile() {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementsByTagName('body')[0].classList.add('noScroll');
      this.menuMobileVisible = true;
    }
  }

  closeMenuMobile() {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementsByTagName('body')[0].classList.remove('noScroll');
      this.menuMobileVisible = false;
    }
  }

  getCategories()
  {
    return this.categoryService.getAll().toPromise()
    .then((response: any) =>
    {
      this.categories = response.sort((a: any) => (a.stared ? -1 : 1));

      this.categories.forEach((category: any) => {
        category.redirect = category.name;
        category.redirect = category.name.replaceAll(' ', '-');
        category.redirect = category.redirect.toLowerCase();
        category.redirect = category.redirect.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      });
    });
  }

  openLogin() {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementsByClassName('modal-login')[0].classList.add('visible');
      document.getElementsByTagName('body')[0].classList.add('noScroll');
    }
  }

  logout(): void{
    this.authService.logout();
    this.router.navigateByUrl('/');
  }

  displayStyle = 'none';

  openPopup() {
    this.displayStyle = "block";
  }
  closePopup() {
    this.displayStyle = "none";
  }

  async handleUser(){
    this.currentUser = await this.authService.getCurrentUser();
    this.userToken = await this.authService.getAccessToken();
    this.avatarUrl = await this.authService.getCurrentAvatar();

    this.guestUser = !(this.userToken != null && this.userToken.length > 0);
    this.userInitials = `${this.currentUser?.person?.profile?.firstname.charAt(0)}${this.currentUser?.person?.profile?.lastname.charAt(0)}`.toUpperCase();

    if (!this.guestUser && this.currentUser.context.activities.length) {
      this.userBalance = this.currentUser.context.activities[0].personStatus.accountBalance.toLocaleString('es-ES');
    }    
  }
}
